module.exports = __webpack_public_path__ + "img/ic_spanish.f6971b06.svg";